// Generated by purs version 0.14.3
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Leibniz = require("../Data.Leibniz/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Effect = require("../Effect/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Node_Buffer = require("../Node.Buffer/index.js");
var Node_Buffer_Class = require("../Node.Buffer.Class/index.js");
var Node_Encoding = require("../Node.Encoding/index.js");
var Test_QuickCheck_Arbitrary = require("../Test.QuickCheck.Arbitrary/index.js");
var Test_QuickCheck_Gen = require("../Test.QuickCheck.Gen/index.js");
var Type_Quotient = require("../Type.Quotient/index.js");
var Unsafe_Coerce = require("../Unsafe.Coerce/index.js");
var ByteString = function (x) {
    return x;
};
var Foldable = function (x) {
    return x;
};
var unsafeThaw = function (v) {
    return v;
};
var unsafeFreeze = ByteString;
var unpack = (function () {
    var $23 = Node_Buffer_Class.toArray(Node_Buffer.mutableBufferEffect);
    return function ($24) {
        return Effect_Unsafe.unsafePerformEffect($23(unsafeThaw($24)));
    };
})();
var toString = function (s) {
    return function (e) {
        return Effect_Unsafe.unsafePerformEffect(Node_Buffer_Class.toString(Node_Buffer.mutableBufferEffect)(e)(unsafeThaw(s)));
    };
};
var showByteString = new Data_Show.Show(function (bs) {
    return "(pack " + (Data_Show.show(Data_Show.showArray(Type_Quotient.showQuotient(Data_Show.showInt)(Type_Quotient.canonicalMod256)))(unpack(bs)) + ")");
});
var semigroupByteString = new Data_Semigroup.Semigroup(function (a) {
    return function (b) {
        return unsafeFreeze(Effect_Unsafe.unsafePerformEffect(Node_Buffer_Class.concat(Node_Buffer.mutableBufferEffect)([ unsafeThaw(a), unsafeThaw(b) ])));
    };
});
var pack = (function () {
    var $25 = Node_Buffer_Class.fromArray(Node_Buffer.mutableBufferEffect);
    var $26 = Data_Functor.map(Data_Functor.functorArray)(Type_Quotient.runQuotient(Type_Quotient.canonicalMod256));
    return function ($27) {
        return unsafeFreeze(Effect_Unsafe.unsafePerformEffect($25($26($27))));
    };
})();
var reverse = function ($28) {
    return pack(Data_Array.reverse(unpack($28)));
};
var singleton = (function () {
    var $29 = Control_Applicative.pure(Control_Applicative.applicativeArray);
    return function ($30) {
        return pack($29($30));
    };
})();
var snoc = function (bs) {
    return function (b) {
        return Data_Semigroup.append(semigroupByteString)(bs)(singleton(b));
    };
};
var uncons = function (bs) {
    return Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(Data_Array.uncons(unpack(bs)))(function (v) {
        return {
            head: v.head,
            tail: pack(v.tail)
        };
    });
};
var tail = (function () {
    var $31 = Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
        return v.tail;
    });
    return function ($32) {
        return $31(uncons($32));
    };
})();
var unsnoc = function (bs) {
    return Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(Data_Array.unsnoc(unpack(bs)))(function (v) {
        return {
            init: pack(v.init),
            last: v.last
        };
    });
};
var newtypeFoldable = new Data_Newtype.Newtype(function () {
    return undefined;
});
var map = function (f) {
    var $33 = Data_Functor.map(Data_Functor.functorArray)(f);
    return function ($34) {
        return pack($33(unpack($34)));
    };
};
var length = (function () {
    var $35 = Node_Buffer_Class.size(Node_Buffer.mutableBufferEffect);
    return function ($36) {
        return Effect_Unsafe.unsafePerformEffect($35(unsafeThaw($36)));
    };
})();
var isEmpty = (function () {
    var $37 = Data_Eq.eq(Data_Eq.eqInt)(0);
    return function ($38) {
        return $37(length($38));
    };
})();
var init = (function () {
    var $39 = Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
        return v.init;
    });
    return function ($40) {
        return $39(unsnoc($40));
    };
})();
var index = function (b) {
    return function (i) {
        return Effect_Unsafe.unsafePerformEffect($foreign.realGetAtOffset(Data_Maybe.Nothing.value)(Data_Maybe.Just.create)(i)(unsafeThaw(b)));
    };
};
var last = function (bs) {
    return index(bs)(length(bs) - 1 | 0);
};
var head = function (v) {
    return index(v)(0);
};
var fromUTF8 = Data_Function.flip(toString)(Node_Encoding.UTF8.value);
var fromString = function (s) {
    return function (e) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(unsafeFreeze)(Effect_Unsafe.unsafePerformEffect(Effect_Exception.catchException(Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Maybe.Nothing.value)))(Data_Functor.map(Effect.functorEffect)(Data_Maybe.Just.create)(Node_Buffer_Class.fromString(Node_Buffer.mutableBufferEffect)(s)(e)))));
    };
};
var toUTF8 = (function () {
    var $41 = Data_Maybe.fromJust();
    var $42 = Data_Function.flip(fromString)(Node_Encoding.UTF8.value);
    return function ($43) {
        return $41($42($43));
    };
})();
var foldableOfOctet = Data_Function["const"](Unsafe_Coerce.unsafeCoerce);
var foldableFoldable = new Data_Foldable.Foldable(function (dictMonoid) {
    return Data_Foldable.foldMapDefaultL(foldableFoldable)(dictMonoid);
}, function (f) {
    return function (z) {
        return function (v) {
            var leibniz = foldableOfOctet(v);
            var f$prime = function (x) {
                return function (o) {
                    return f(x)(Data_Leibniz.coerceSymm(leibniz)(o));
                };
            };
            return $foreign.foldl(f$prime)(z)(v);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            var leibniz = foldableOfOctet(v);
            var f$prime = function (o) {
                return function (x) {
                    return f(Data_Leibniz.coerceSymm(leibniz)(o))(x);
                };
            };
            return $foreign.foldr(f$prime)(z)(v);
        };
    };
});
var eqByteString = new Data_Eq.Eq(function (a) {
    return function (b) {
        return Data_Eq.eq(Data_Eq.eqArray(Type_Quotient.eqQuotient(Data_Eq.eqInt)(Type_Quotient.canonicalMod256)))(unpack(a))(unpack(b));
    };
});
var ordByteString = new Data_Ord.Ord(function () {
    return eqByteString;
}, function (a) {
    return function (b) {
        return Data_Ord.compare(Data_Ord.ordArray(Type_Quotient.ordQuotient(Data_Ord.ordInt)(Type_Quotient.canonicalMod256)))(unpack(a))(unpack(b));
    };
});
var empty = pack([  ]);
var monoidByteString = new Data_Monoid.Monoid(function () {
    return semigroupByteString;
}, empty);
var cons = function (b) {
    return function (bs) {
        return Data_Semigroup.append(semigroupByteString)(singleton(b))(bs);
    };
};
var arbitraryByteString = new Test_QuickCheck_Arbitrary.Arbitrary(Data_Functor.map(Test_QuickCheck_Gen.functorGen)(toUTF8)(Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbString)));
module.exports = {
    unsafeFreeze: unsafeFreeze,
    unsafeThaw: unsafeThaw,
    empty: empty,
    singleton: singleton,
    pack: pack,
    unpack: unpack,
    index: index,
    cons: cons,
    snoc: snoc,
    uncons: uncons,
    unsnoc: unsnoc,
    head: head,
    tail: tail,
    last: last,
    init: init,
    length: length,
    isEmpty: isEmpty,
    map: map,
    reverse: reverse,
    foldableOfOctet: foldableOfOctet,
    fromString: fromString,
    toString: toString,
    toUTF8: toUTF8,
    fromUTF8: fromUTF8,
    semigroupByteString: semigroupByteString,
    monoidByteString: monoidByteString,
    eqByteString: eqByteString,
    ordByteString: ordByteString,
    arbitraryByteString: arbitraryByteString,
    showByteString: showByteString,
    newtypeFoldable: newtypeFoldable,
    foldableFoldable: foldableFoldable,
    unsafeIndex: $foreign.unsafeIndex,
    foldl: $foreign.foldl,
    foldr: $foreign.foldr,
    ASCII: Node_Encoding.ASCII,
    Base64: Node_Encoding.Base64,
    Binary: Node_Encoding.Binary,
    Hex: Node_Encoding.Hex,
    Latin1: Node_Encoding.Latin1,
    UCS2: Node_Encoding.UCS2,
    UTF16LE: Node_Encoding.UTF16LE,
    UTF8: Node_Encoding.UTF8
};
